export enum CODETYPE {
  TEXT,
  FIGUREFORM
}
